import { styled, css } from "styled-components";
import { PageSectionContainer } from "../../../../Components/Styled/SectionContainer";
import { useAppSelector } from "../../../../Hooks/Hooks";
import {
    selectLoadingData,
    selectLandingData,
} from "../../../../Redux/DataSlice/DataSlice";
import { DataDisplay } from "../../../../Components/DataDisplay/DataDisplay";
import LIQUIBOT_IMAGE from "../../../../CustomLiquiImages/LandingLogo.png";
import { White } from "../../../../Theme/ColorPallete";
import { darken, lighten } from "polished";

const LandingContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    gap: 40px;
    align-items: center;
    padding: 120px 0px;
    width: 100%;

    ${({ theme }) => css`
        @media screen and (max-width: ${theme.breakpoint}px) {
            background: transparent;
        }
    `}
`;

const LandingPageSectionContainer = styled(PageSectionContainer)`
    width: 100%;
`;

const LiquiBotImage = styled.img``;
const LiquiBotIntro = styled.div`
    font-weight: 700;
    max-width: 480px;
    text-align: center;
    ${({ theme }) => css`
        font-size: ${theme.fontSize.large}px;
    `}
`;

const LandingButtonsContainer = styled.div`
    display: flex;
    gap: 20px;
    justify-content: center;
    ${({ theme }) => css`
        @media screen and (max-width: ${theme.breakpoint}px) {
            flex-direction: column;
            align-items: center;
            gap: 10px;
        }
    `}
`;
export const LandingDiscordLink = styled.a`
    text-decoration: none;
    &:hover {
        cursor: pointer;
        ${({ theme }) => css`
            background: ${darken(0.02, theme.colors.discordBlue)};
        `}
    }
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    padding: 10px;
    ${({ theme }) => css`
        background: ${theme.colors.discordBlue};
        border: 1px solid ${theme.colors.discordBlue};
    `}
`;
const LandingScroller = styled.button`
    border: none;
    outline: none;
    margin: 0;
    text-decoration: none;
    border-radius: 4px;
    font-family: inherit;
    padding: 10px;
    transition: ${({ theme }) => theme.animationTime.short}s all ease;
    &:hover {
        cursor: pointer;
        ${({ theme }) => css`
            background: ${theme.colors.background === White
                ? darken(0.035, theme.colors.background)
                : lighten(0.1, theme.colors.background)};
        `}
    }
    ${({ theme }) => css`
        background: ${theme.colors.background};
        border: 1px solid ${theme.colors.discordBlue};
    `}
`;
interface LandingLinkTextProps {
    $followTheme: boolean;
}
export const LandingLinkText = styled.div<LandingLinkTextProps>`
    text-transform: uppercase;
    font-family: inherit;
    font-weight: 600;
    ${({ theme, $followTheme }) => css`
        font-size: ${theme.fontSize.small}px;
        color: ${$followTheme ? theme.colors.text : White};
    `}
`;

export const Landing = () => {
    const staticData = useAppSelector(selectLandingData);
    const loading = useAppSelector(selectLoadingData);
    const scrollTo = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };
    return (
        <LandingPageSectionContainer id="landing-container">
            <LandingContainer>
                <LiquiBotIntro>
                    A text based
                    <br /> RPG for your server!
                </LiquiBotIntro>
                <LiquiBotImage src={LIQUIBOT_IMAGE} />
                <LandingButtonsContainer>
                    <LandingDiscordLink
                        href="https://discord.com/oauth2/authorize?client_id=1074436572172259500&permissions=8&scope=bot"
                        target="_blank"
                    >
                        <LandingLinkText $followTheme={false}>
                            Add to server
                        </LandingLinkText>
                    </LandingDiscordLink>
                    <LandingScroller
                        onClick={() => scrollTo("conversation-container")}
                    >
                        <LandingLinkText $followTheme>
                            Offered features
                        </LandingLinkText>
                    </LandingScroller>
                </LandingButtonsContainer>
                <DataDisplay loading={loading} stats={staticData} />
            </LandingContainer>
        </LandingPageSectionContainer>
    );
};
